import { copyToClipboard } from "@/utils/clipboard/copyToClipboard";
import Link from "next/link";
import toast from "react-hot-toast";

export function ShareLinks({ shareText, shareLink }) {
  const shareLinks = [
    {
      name: "Twitter",
      link: `https://twitter.com/intent/tweet?text=${shareText}&url=${shareLink}`,
    },
    {
      name: "LinkedIn",
      link: `https://www.linkedin.com/shareArticle?mini=true&url=${shareLink}&title=${shareText}&summary=${shareText}&source=${shareLink}`,
    },
    {
      name: "Reddit",
      link: `https://reddit.com/submit/?url=${shareLink}&resubmit=true&title=${shareText}`,
    },
  ];

  return (
    <div className="flex flex-col justify-center gap-4">
      {shareLinks.map((share) => (
        <Link
          target="_blank"
          key={share.name}
          href={share.link}
          className="font-sans hover:bg-gray-100 p-2 rounded-sm"
        >
          {share.name}
        </Link>
      ))}
      <button
        className="font-sans hover:bg-gray-100 p-2 rounded-sm text-left w-full"
        onClick={() => {
          copyToClipboard(`${shareLink}?ref=share_link`);
          toast.success("Copied to clipboard");
        }}
      >
        Copy to clipboard
      </button>
    </div>
  );
}
